import { asProblem, problemMessage } from '@pos/admin-ui';

type T = Parameters<typeof problemMessage>[0];

/** A translated message for a failed call, from a query or mutation error. */
export const asProblemMessage = (t: T, error: unknown) => problemMessage(t, asProblem(error));
